class Navigation {
    toggleMenu() {
        this.handleMenu(!this.menuOpen ? "open" : "close", "both");
    }

    handleMenu(state, side) {
        switch (state) {
            case "open":
                this.menuOpen = true;
                switch (side) {
                    case "left":
                        this.leftSideMenu.classList.add("active");
                        break;

                    case "right":
                        this.rightSideMenu.classList.add("active");
                        break;

                    default:
                    case "both":
                        this.leftSideMenu.classList.add("active");
                        this.rightSideMenu.classList.add("active");
                        break;
                }
                break;

            case "close":
                switch (side) {
                    case "left":
                        this.leftSideMenu.classList.remove("active");
                        break;

                    case "right":
                        this.rightSideMenu.classList.remove("active");
                        break;

                    default:
                    case "both":
                        this.leftSideMenu.classList.remove("active");
                        this.rightSideMenu.classList.remove("active");
                        break;
                }
                break;
        }
        if (this.leftSideMenu.classList.contains("active") || this.rightSideMenu.classList.contains("active")) {
            this.pageReference.classList.add("menu-open");
            this.menuOpen = true;
        } else {
            this.pageReference.classList.remove("menu-open");
            this.menuOpen = false;
        }
    }

    init() {
        this.menuOpen = false;
        this.leftSideMenu = document.querySelector(".side-menu-left");
        this.rightSideMenu = document.querySelector(".side-menu-right");
        this.pageReference = document.getElementById("page-overlay");
        if (this.leftSideMenu && this.rightSideMenu && this.pageReference) {
            this.leftSideMenu.addEventListener("mouseenter", function (e) {
                app.navigation.handleMenu("open", "left");
            });
            this.rightSideMenu.addEventListener("mouseenter", function (e) {
                app.navigation.handleMenu("open", "right");
            });
            this.leftSideMenu.addEventListener("mouseleave", function (e) {
                app.navigation.handleMenu("close", "left");
            });
            this.rightSideMenu.addEventListener("mouseleave", function (e) {
                app.navigation.handleMenu("close", "right");
            });
        }
        app.events.sub(["page_change", "page_inject"], function () {
            $(".side-menu-left,.side-menu-right").removeClass("active");
            $("#page").removeClass("menu-open");

            $("a").each(function (e) {
                $(this).removeClass("active");
                if (this.href === window.location.href || this.href === (window.location.origin + window.location.pathname) || $(this).hasClass("force-active")) {
                    $(this).addClass("active");
                }
            });
            $(".auto-height-items").each(function () {
                window.autoHeighttemsMaxHeight = 0;
                window.autoHeightItems = $(this).find(".auto-height");
                if (window.autoHeightItems.length) {
                    window.autoHeightItems.each(function () {
                        let itemHeight = $(this).height();
                        if (itemHeight > window.autoHeighttemsMaxHeight) {
                            window.autoHeighttemsMaxHeight = itemHeight;
                        }
                    });
                    window.autoHeightItems.height(window.autoHeighttemsMaxHeight);
                }
            });
        });
        if (app.config.user === undefined) {
            // if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            //     app.util.setCookie("theme", "dark_mode");
            //     $("html").attr("theme", "dark_mode");
            // } else {
            //     app.util.setCookie("theme", "standard");
            //     $("html").attr("theme", "standard");
            // }
            app.events.sub(["page_change"], function () {
                app.analytics.checker();
            });
        } else {
            if (!app.config.user.v) {
                app.events.sub(["page_change"], function () {
                    app.analytics.checker();
                });
            }
        }

        let previousScrolls = [{x: 0, y: 0}];
        app.events.winSub("popstate", function (e) {
            if ((!e.target.location.hash || $(e.target.location.hash).length === 0) && e.target.location.pathname.indexOf("/") === 0) {
                let search = e.target.location.search;
                if (search.length) {
                    search = search + "&navigation_back=true";
                } else {
                    search = "?navigation_back=true";
                }
                app.ajax.inject(e.target.location.pathname + search, "#page", false, function () {
                    app.events.pub("page_change");
                    app.events.pub("page_leave");
                    app.analytics.pageView();
                    if (previousScrolls.length) {
                        let prevs = previousScrolls.pop();
                        window.scrollTo(prevs.x, prevs.y);
                    }
                });
                app.modal.close();
                app.alert.close();
            } else if (e.target.location.hash) {
                e.preventDefault();
                let hashElement = $(e.target.location.hash).eq(0);
                if (hashElement) {
                    setTimeout(() => {
                        window.scrollTo({top: hashElement.offset().top - 100, left: 0, behavior: "auto"});
                    }, 1);
                }
            }
        });
        $(document).on("keyup change select", "form", function (event) {
            if ($(event.target).parents(".hide-if-dirty").length === 0) {
                let submitButton = $(this).find("[type='submit'].btn-primary");
                if (submitButton.length) {
                    let dirtyElements = $(this).find(".hide-if-dirty");
                    submitButton.addClass("btn-green");
                    if (dirtyElements.length) {
                        submitButton.on("click", () => {
                            setTimeout(() => {
                                dirtyElements.fadeIn(200);
                            }, 2000);
                        })
                        dirtyElements.fadeOut(200);
                    }
                }
            }
        });
        app.events.docSub("scroll", function () {
            if (document.playButton) {
                if ((window.scrollY || document.documentElement.scrollTop) > 500) {
                    document.playButton.style.opacity = "1";
                } else {
                    document.playButton.style.opacity = "0";
                }
            }
        });
        app.events.docSub("click", function (e) {
            let ct = app.util.findParent("card-toggle", e.target, 2);
            if (ct) {
                let ctt = $(ct).attr("data-toggle");
                if (e.target.classList.contains("card-body") || app.util.findParent("card-header", e.target, 1)) {
                    if (ct.classList.contains("toggled")) {
                        ct.classList.remove("toggled");
                        if (ctt) {
                            let ctte = $("[data-toggle='" + ctt + "']");
                            ctte.removeClass("toggled");
                        }
                        return;
                    } else {
                        ct.classList.add("toggled");
                        if (ctt) {
                            let ctte = $("[data-toggle='" + ctt + "']");
                            ctte.addClass("toggled");
                        }
                        return;
                    }
                }
            }
            if (app.util.findParent("instantMessages", e.target)) {
                const dropdown = $("#instantMessages .dropdown-menu");
                if (dropdown.hasClass("open")) {
                    dropdown.slideUp(100, () => {
                        if (app.chatWrapper && app.chatWrapper.CegoXMPP) {
                            app.chatWrapper.CegoXMPP.showPane('directChatDock');
                        }
                    });
                } else {
                    dropdown.slideDown(100);
                }
                dropdown.toggleClass("open");
                return;
            }
            let a = app.util.findParent('a', e.target);
            if (a) {
                if (e.view.location.href === a.href) {
                    e.preventDefault();
                    return;
                }
                const host = e.view.location.origin;
                const link = a.href.replace(host, "");

                let activeLinks = app.util.findParent("add-active-links", e.target);
                if (activeLinks) {
                    activeLinks = activeLinks.querySelectorAll("a");
                    for (let i in activeLinks) {
                        if (activeLinks[i].classList) {
                            activeLinks[i].classList.remove("active");
                        }
                    }
                    a.classList.add("active");
                }

                let injectId = a.getAttribute("data-inject-id");
                if (injectId && document.querySelector(injectId) === null) {
                    injectId = "#page";
                }
                if (injectId) {
                    e.preventDefault();
                    if (a.getAttribute("data-inject-history-off")) {
                        app.ajax.inject(link, injectId, false);
                    } else {
                        app.ajax.inject(link, injectId);
                    }
                } else {
                    let modal = a.getAttribute("data-modal");
                    if (modal) {
                        app.ajax.modal(link, modal);
                        e.preventDefault();
                    } else {
                        let target = a.target;
                        if (target.length === 0 && link.indexOf("/") === 0) {
                            if (link.indexOf("#") === -1) {
                                e.preventDefault();
                                if (typeof window.live_counter === "undefined") {
                                    app.ajax.inject(link, "#page", true, function () {
                                        app.events.pub("page_change");
                                        previousScrolls.push({x: window.scrollX, y: window.scrollY});
                                        window.scrollTo(0, 0);
                                        app.analytics.pageView();
                                    });
                                }
                            } else {
                                let target = document.getElementById(link.substring(link.indexOf("#") + 1));
                                if (target) {
                                    let modal = $("modal");
                                    if (modal.length) {
                                        e.preventDefault();
                                        modal.find(".modal-wrapper")[0].scrollBy({top: target.getBoundingClientRect().top - 100, left: 0, behavior: "auto"});
                                    } else {
                                        e.preventDefault();
                                        window.scrollBy({top: target.getBoundingClientRect().top - 160, left: 0, behavior: "auto"});
                                    }
                                }
                            }
                        } else {
                            if (link !== "") {
                                if (link.indexOf(app.config.domain) === 8 || link.indexOf("/") === 0) {
                                    e.preventDefault();
                                    if (target === "") {
                                        target = "_blank";
                                    }
                                    switch (target) {
                                        case "modal":
                                            app.ajax.modal(link, a.getAttribute("target-css"));
                                            break;

                                        case "modal_clear":
                                            app.ajax.modalClear(link, a.getAttribute("target-css"));
                                            break;

                                        case "new_window":
                                            window.open(link, "", "location=0,menubar=0,scrollbars=0,status=0,titlebar=0,toolbar=0,width=" + Math.min(screen.width * 0.8, 1300) + ",height=" + Math.min(screen.height * 0.8, 800) + ",popup=1");
                                            break;

                                        case "administration":
                                            if (window.location.href.indexOf("administration") < 0) {
                                                window.open(link, "_blank");
                                            } else {
                                                window.open(link, "_self");
                                            }
                                            break;

                                        case "opener":
                                            if (window.opener && !window.opener.closed && window.opener !== window) {
                                                window.blur();
                                                window.opener.focus();
                                                window.opener.location.href = link;
                                            } else {
                                                window.location.href = link;
                                            }
                                            break;

                                        case "overlay":
                                            app.alert.overlay(link);
                                            break;

                                        default:
                                            window.open(link, target);
                                            break;
                                    }
                                } else {
                                    app.analytics.linkOut(link);
                                    e.preventDefault();
                                    window.open(link, "_blank");
                                }
                            }
                        }
                    }
                }
            }
        });

        app.events.docSub('submit', function (e) {
            e.preventDefault();
        });

        app.events.docSub('keyup', function (e) {
            if (e.keyCode === 27) {
                app.alert.close();
                app.modal.close();
            }
            if (e.keyCode === 37) {
                jQuery('.control.control-left').click();
            }
            if (e.keyCode === 39) {
                jQuery('.control.control-right').click();
            }
        });
    }

    translatePageModule(pageId, name, fromSiteId, toSiteId) {
        app.ajax.get("/administration/pages/translate", {"pageId": pageId, "name": name, "fromSiteId": fromSiteId, "toSiteId": toSiteId}, (response) => {
            const el = $("[name='data[" + name + "]']").eq(0);
            const id = el.attr("id");
            if (typeof document.wysiwyg !== "undefined" && typeof document.wysiwyg[id] !== "undefined") {
                $("#" + id).trumbowyg("html", response.translation);
            } else {
                el.val(response.translation);
            }
        });
    }
}